@if (dogs) {
  @for (dog of dogs; track dog; let i = $index) {
    <mat-card class="dog-summary-background-blue" [class.no-milestones]="dog['milestones'].length === 0">
      <mat-card-header (click)="viewProfile(i)">
        <div mat-card-avatar [style.background-image]="dog['profile_picture']" class="card-image-expand"></div>
        <mat-card-title class="u-text-color_white"><span class="mat-display-medium u-text-color_white">{{
          dog["name"]
          }}
          <span class="mat-body-medium u-text-color_gray-blue">
            @if (dog['latest_milestone']) {
              -
              {{ rookieMilestone.includes(dog['latest_milestone']['id']) ? 'Rookie Rover' :
              dog["latest_milestone"]['internal_milestone_name'] }}
            }
          </span>
        </span>
      </mat-card-title>
      <mat-card-subtitle class="dog-summary_sub {{!dog['latest_milestone'] ? 'fix-height' : ''}}">
        @if (deviceIsMobile) {
          <a class="remove-styling" (click)="viewProfile(i)">profile ></a>
        }
      </mat-card-subtitle>
      <mat-card-subtitle>
        <div class="mat-body-medium u-text-color_gray-blue">
          {{ dog["name"] + " is " + dog["dog_status"] }}
        </div>
      </mat-card-subtitle>
      <mat-card-subtitle class="no-wrap mat-body-medium u-text-color_gray-blue">Member since:
        {{ dog["first_check_in"] }}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      @if (deviceIsMobile) {
        <mat-divider class="white-divider" [inset]="true"> </mat-divider>
      }
      @if (dog['all_milestones'].length !== 0) {
        <app-milestone-banner [milestones]="dog['all_milestones']"
          [completed_milestones]="dog['completed_milestones']" [dogId]="dog['id']" [page]="page">
        </app-milestone-banner>
      }
      @if (!deviceIsMobile) {
        <mat-divider class="white-divider" [inset]="false" [vertical]="true"></mat-divider>
        <app-arrow-text-button isMatButton="true" (click)="viewProfile(i)">
          <div matButtonText>profile</div>
        </app-arrow-text-button>
      }
    </mat-card-content>
  </mat-card>
}
}